'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reselect = require('reselect');
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
exports.default = function (formId) {
  return (0, _reselect.createSelector)(function (state) {
    return (0, _fieldInfo.getValue)(state, formId, 'claims') === 'N';
  }, function (state) {
    return (0, _fieldInfo.getValue)(state, formId, 'convictions') === 'N';
  }, function (state) {
    return (0, _fieldInfo.getValue)(state, formId, 'disallowedOccupations') === 'N';
  }, function (state) {
    return (0, _fieldInfo.getValue)(state, formId, 'vehicleInsured') === 'Y';
  }, function (state) {
    return (0, _fieldInfo.getValue)(state, formId, 'modified') === 'N' || (0, _fieldInfo.getValue)(state, formId, 'modifiedForDisability') === 'Y';
  }, function (noClaims, noConvictions, allowedOccupation, vehicleInsured, modified) {
    return noClaims && noConvictions && allowedOccupation && vehicleInsured && modified;
  });
};